import { RootState } from '@reducers';

export const selectPersonalAccidentQuoteResultPage = (state: RootState) => state.personalAccidentQuoteResultPageReducer;
